import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

export default {
  state: {
    promo: 0,
  },
  getters: {
    promo (state) {
      return state.promo
    }
  },
  mutations: {
    SET_PROMO (state, data) {
      state.promo = data
    }
  },
  actions: {
  },

}
